export interface GetBillingCouponCheckResponse {
  discountType: number;
  discountValue: number;
}

// 折扣碼限定付款週期（2026-10）：碼要求的週期與本次購買不符時後端回 40002，
// data 帶該碼要求的週期（1 月繳 / 2 年繳），前端據此顯示「僅限年繳／月繳」文案
export const BILLING_COUPON_PERIOD_MISMATCH_CODE = 40002;

export interface GetBillingCouponCheckPeriodMismatchData {
  requiredPeriod: number;
}

// coupon/check 的完整回應：20000 帶折扣、40002 帶 requiredPeriod、其他錯誤碼（40000）無 data
export type GetBillingCouponCheckResult =
  | { code: 20000; msg: string; data: GetBillingCouponCheckResponse }
  | {
      code: typeof BILLING_COUPON_PERIOD_MISMATCH_CODE;
      msg: string;
      data: GetBillingCouponCheckPeriodMismatchData;
    }
  | { code: number; msg: string; data?: undefined };
